import './App.css';

import * as React from 'react';
import Faq from '../../pages/Faq/Faq';
import AppPartner from '../../pages/AppPartner/AppPartner';
import {BrowserRouter, NavLink, Route} from "react-router-dom";
import Logo from '../../resources/images/logo.png';

const App = () => (
    <BrowserRouter>
        <div>
            <div className="banner">
                <a href="https://skubana.com">
                    <img className="logo" src={Logo}/>
                </a>
            </div>
            <div className="app-container">
                <nav className="sku-nav">
                    <ul>
                        <li className="nav-section">
                            <a href="/spec/">Full API Reference</a>
                        </li>
                        <li className="nav-section">Resources</li>
                        <li className="nav-item">
                            <NavLink to="/faq" activeClassName="active-nav">FAQ</NavLink>
                        </li>
                    </ul>
                </nav>

                <div className="content">
                    <Route path="/" exact={true} component={AppPartner}/>
                    <Route path="/faq" component={Faq}/>
                </div>
            </div>
        </div>
    </BrowserRouter>
);

export default App;



// WEBPACK FOOTER //
// ./src/pages/App/App.tsx